import React, { useEffect, useState } from 'react';
import GuestBar from "../../components/GuestInfo/GuestBar";
import { Breadcrumbs, Typography } from "@mui/material";
import { useLocation } from 'react-router-dom';

const BasicAuth = () => {
    const location = useLocation();
    const [pageTitle, setPageTitle] = useState('');

    useEffect(() => {
        const getPage = () => {
            const path = location.pathname;
            // Aquí defines los títulos según la ruta
            switch (path) {
                case '/customization':
                    return 'Marketing';
                case '/marketing/videos':
                    return 'Marketing - Videos';
                case '/marketing/images':
                    return 'Marketing - Images';
                case '/marketing/downloads':
                    return 'Marketing - Downloads';
                case '/ratings/my_ratings':
                    return 'Guest Feedback';
                case '/contact':
                    return 'Contact';
                case '/account':
                    return 'Profile';
                case '/auth/change_password':
                    return 'Profile - Change Password';
                default:
                    return 'Unknown Page';
            }
        };

        setPageTitle(getPage());
    }, [location.pathname]);

    return (
        <GuestBar>
            <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                <Typography color="text.primary">
                    {pageTitle}
                </Typography>
            </Breadcrumbs>
        </GuestBar>
    );
};

export default BasicAuth;
